jQuery( document ).ready( function ( $ ) {
	const $body = $( 'body' );

	if ( !$body.hasClass( 'post-type-archive-uxsc-collection' ) && !$body.hasClass( 'search-results' ) ) {
		return;
	}

	const $loadMoreImage = $( '.collection__load-more__image, .search__load-more__image' );

	document.addEventListener( "facetwp-loaded", () => {
		if ( FWP.settings.pager.page >= FWP.settings.pager.total_pages ) {
			$loadMoreImage.hide();
			$( '.facetwp-no-results' ).hide();
		}
	} );
} );